import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          clear();
          localStorage.removeItem("cp_coupon"); localStorage.removeItem("cp_coupon_data");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("failed"); return; }
        if (attempts.current++ < 12) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { if (active) setStatus("error"); }
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center">
      {status === "checking" && (<><Loader2 className="h-12 w-12 text-terracotta mx-auto animate-spin" /><h1 className="font-heading text-3xl text-ink mt-6">Vérification du paiement…</h1><p className="text-ink-muted mt-2">Merci de patienter quelques instants.</p></>)}
      {status === "paid" && (<><CheckCircle2 className="h-14 w-14 text-sage mx-auto" /><h1 className="font-heading text-4xl text-ink mt-6">Votre commande est confirmée</h1><p className="text-ink-muted mt-3">Merci pour votre achat ! Vos eBooks sont disponibles dans votre espace client. Un e-mail de confirmation vous a été envoyé.</p><Button asChild className="mt-8 bg-terracotta hover:bg-terracotta-dark text-white rounded-md px-8" data-testid="go-to-ebooks"><Link to="/compte/ebooks">Accéder à mes eBooks</Link></Button></>)}
      {["failed", "error", "pending"].includes(status) && (<><AlertCircle className="h-12 w-12 text-destructive mx-auto" /><h1 className="font-heading text-3xl text-ink mt-6">{status === "pending" ? "Paiement en cours de traitement" : "Le paiement n'a pas abouti"}</h1><p className="text-ink-muted mt-2">{status === "pending" ? "Votre paiement est en cours de confirmation. Vos eBooks apparaîtront dans votre espace client dès validation." : "Aucun montant n'a été débité. Vous pouvez réessayer."}</p><Button asChild variant="outline" className="mt-6 border-line"><Link to="/panier">Retour au panier</Link></Button></>)}
    </div>
  );
}
